import React from 'react'
import { CSVLink } from 'react-csv'

import alertIcon from '../../../../icones/iconesMensagens/alerta_atencao.svg'
import downloadIcon from '../../../../icones/iconesVersaoVerde/download.svg'
import ActionIcon from '../../../Mantine/ActionIcon'
import Botao from '../../../Mantine/Botao/index.jsx'
import Modal from '../../../Mantine/Modal/index.jsx'

import * as S from './styles.js'

export default function Alerta({
  opened,
  message,
  onClick,
  invalidSimcards = []
}) {
  const hasInvalidSimcards = invalidSimcards.length > 0
  const dadosParaDownload = JSON.parse(
    JSON.stringify(
      invalidSimcards.map((simcard) => ({
        Linhas: "'" + simcard
      }))
    )
  )

  const downloadInvalidSimcards = () => {
    const csvLink = document.getElementById('download_invalid_simcards')
    if (csvLink) {
      csvLink.click()
    }
  }

  return (
    <Modal
      titulo="Atenção!"
      width="450px"
      type="alerta"
      opened={opened}
      positionTitle="center"
      hasIcon
      icon={alertIcon}
    >
      <S.ModalAlert>
        <S.Message className="modal-alert">{message}</S.Message>

        {hasInvalidSimcards && (
          <>
            <Botao
              rightIcon={
                <ActionIcon
                  alt="blankSlateIcon"
                  variant="transparent"
                  icon={downloadIcon}
                />
              }
              uppercase={false}
              label="Baixar linhas"
              variant="subtle"
              onClick={downloadInvalidSimcards}
            />

            <CSVLink
              id="download_invalid_simcards"
              filename="Linhas_invalidas.csv"
              className="d-none"
              data={dadosParaDownload}
            />
          </>
        )}

        <Botao label="Fechar" onClick={onClick} />
      </S.ModalAlert>
    </Modal>
  )
}
